<div class="modal" [@showHide]>
  <div class="modal__content">
    <div class="window">
      <i class="window__close icon-close" (click)="close()"></i>
      <ng-template #content></ng-template>
    </div>
  </div>
</div>
